import request from "../util/request"

export default async function () {
  const element = document.getElementById("js-payment-processing-data")

  if (element) {
    const paymentProcessingData = element.dataset

    let clientSecret = paymentProcessingData.stripeClientSecret
    const stripe = Stripe(paymentProcessingData.stripePublicKey)

    if (paymentProcessingData.chargeStatus == "three_d_secure_required") {
      let _result = await stripe.confirmCardPayment(clientSecret)
      checkStatusForRedirect(paymentProcessingData)
    } else {
      checkStatusForRedirect(paymentProcessingData)
    }
  }
}

function checkStatusForRedirect(paymentProcessingData, timeout = 1000) {
  setTimeout(async function () {
    let result = await request("GET", paymentProcessingData.statusCheckUrl)
    let { ok, processing } = result.data

    if (ok) {
      history.pushState({}, null, result.meta.redirect)
      history.go()
    } else if (processing) {
      checkStatusForRedirect(paymentProcessingData)
    }
  }, timeout)
}
